import React from "react";

/** Single flex child for the route outlet (fragments break footer height). */
function CmsPageRoot({ children }) {
  return <div className="cms-website-page-root">{children}</div>;
}

export default CmsPageRoot;
